/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Defectp21Inputs */



/**
* | output |
* | --- |
* | "Right/low pump defect" |
*
* @param {Br_History_Key_Defectp21Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_defectp21 = /** @type {((inputs?: Br_History_Key_Defectp21Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Defectp21Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Right/low pump defect")
	return /** @type {LocalizedString} */ ("Défaut pompe droite/basse")
});
export { br_history_key_defectp21 as "br_history_key_defectP2" }